import { Link } from "react-router-dom";
import { ArrowUpRight, FileCheck2 } from "lucide-react";
import { regulatory } from "@/content/site";

// In-house regulatory team paragraph + link to API export case studies.
export const RegulatoryNote = ({ className = "", testId = "regulatory-note" }) => (
  <div className={className} data-testid={testId}>
    <p className="flex gap-3 text-[15px] leading-relaxed text-muted">
      <FileCheck2 className="mt-1 h-5 w-5 shrink-0 text-accent" strokeWidth={1.5} />
      <span>{regulatory.text}</span>
    </p>
    <Link
      to={regulatory.link.to}
      className="group mt-4 inline-flex items-center gap-1.5 pl-8 text-[14px] font-medium text-accent underline-offset-4 hover:underline"
      data-testid={`${testId}-link`}
    >
      {regulatory.link.label}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </Link>
  </div>
);
